import { render, staticRenderFns } from "./WeightRadioGroup.vue?vue&type=template&id=72544274&"
import script from "./WeightRadioGroup.vue?vue&type=script&lang=js&"
export * from "./WeightRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports